import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'

import 'mdbvue/build/scss/mdb.scss'

import Navigation from '@/components/Navigation.vue'
import Heading from '@/components/Heading.vue'
import PageFooter from '@/components/Footer.vue'

Vue.use(BootstrapVue)
Vue.component('Navigation', Navigation)
Vue.component('Heading', Heading)
Vue.component('PageFooter', PageFooter)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if ('section' in to.meta) {
    document.title = `${to.meta.section} - HKUST UChoir`
  } else {
    to.meta['section'] = to.meta.name
    document.title = `${to.meta.name} - HKUST UChoir`
  }
  if (document.querySelector('.ps') !== null) { document.querySelector('.ps')!.scrollTop = 0 }
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
